// extracted by mini-css-extract-plugin
export default {"row11":"AnthropometricForm_row11__QQGbD"};